/**
 * @file Route: checkout
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import "components/Title";
import { CheckoutShipping } from "components/Checkout/Shipping";
// import { CheckoutAddress } from "components/Checkout/Address";
import { CheckoutAddressUnique } from "components/Checkout/AddressUnique";
import { CheckoutPayment } from "components/Checkout/Payment";
import { CheckoutEmail } from "components/Checkout/Email";
import { Checkout } from "components/Checkout";
import "./index.scss";

console.log("Route checkout/index.js mounted.");

Checkout();
CheckoutShipping();
// CheckoutAddress();
CheckoutAddressUnique();
CheckoutPayment();
CheckoutEmail();